import script from "./sport-live-tv-dropdown-trigger.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-dropdown-trigger.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-dropdown-trigger.vue?vue&type=style&index=0&id=ba6f0cbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba6f0cbe"]])

export default __exports__